/* eslint-disable */
import Api from '@/services/Api'

export default {
  login(credentials) {
    try {
     return Api().post('login/', credentials);
    } catch (err) {
      console.log(err)
      return err
     }
  },
    getDashboard(){
        try {
            return Api().get('dashboard/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    getGoogleClassDashboard(){
        try {
            return Api().get('dashboard/google');
        }catch(err){
            console.log(err);
            return err
        }
    },

    logout(credentials) {
    try {
      throw "Test"
      // return Api().post('auth/logout', credentials);
    } catch (err) {
      // console.log(err)
      return {}
    }
  }
}